'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = require('babel-runtime/helpers/extends');

var _extends7 = _interopRequireDefault(_extends6);

exports.HttpMiddleware = HttpMiddleware;

var _fsa = require('@zaibot/fsa');

var _fsaSaga = require('@zaibot/fsa-saga');

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _resource = require('../resource');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let configTimeout = 8000;
let http404 = 404;
function HttpMiddleware(api, path) {
    return descriptor => {
        var _descriptor$actions = descriptor.actions;
        let CREATE = _descriptor$actions.CREATE,
            READ = _descriptor$actions.READ,
            UPDATE = _descriptor$actions.UPDATE,
            DELETE = _descriptor$actions.DELETE,
            LIST = _descriptor$actions.LIST;

        let fnCreate = sagaCreate(api, path, descriptor);
        let fnRead = sagaRead(api, path, descriptor);
        let fnUpdate = sagaUpdate(api, path, descriptor);
        let fnDelete = sagaDelete(api, path, descriptor);
        let fnList = sagaList(api, path, descriptor);
        return function* (action, next) {
            if ((0, _fsa.isType)(action, CREATE)) {
                yield* fnCreate(next)(action);
            } else if ((0, _fsa.isType)(action, READ)) {
                yield* fnRead(next)(action);
            } else if ((0, _fsa.isType)(action, UPDATE)) {
                yield* fnUpdate(next)(action);
            } else if ((0, _fsa.isType)(action, DELETE)) {
                yield* fnDelete(next)(action);
            } else if ((0, _fsa.isType)(action, LIST)) {
                yield* fnList(next)(action);
            }
        };
    };
}
function sagaCreate(api, path, descriptor) {
    return next => function* (action) {
        let item = (0, _resource.stripFields)(action.payload.item);
        delete item[descriptor.options.id];

        var _ref = yield (0, _effects.race)({
            cancel: (0, _fsaSaga.take)([descriptor.actions.CREATE_CANCEL, descriptor.actions.RESET]),
            res: api.post('' + path, item),
            timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout)
        });

        let res = _ref.res,
            cancel = _ref.cancel,
            timeout = _ref.timeout;

        if (res && res.ok) {
            let data = yield (0, _effects.call)(() => res.json());
            yield (0, _fsaSaga.put)(descriptor.actions.CREATE_SUCCESS({
                item: (0, _extends7.default)({}, action.payload.item, data, (0, _defineProperty3.default)({}, _resource.fields.id, descriptor.data.id(data)))
            }));
            yield* next();
        } else if (cancel) {
            yield* next();
        } else if (timeout) {
            yield (0, _fsaSaga.put)(descriptor.actions.CREATE_FAILURE({ item: action.payload.item, reason: 'timedout' }));
            yield* next();
        } else {
            yield (0, _fsaSaga.put)(descriptor.actions.CREATE_FAILURE({ item: action.payload.item, reason: res.status + ' ' + res.statusText }));
            yield* next();
        }
    };
}
function sagaRead(api, path, descriptor) {
    return next => function* (action) {
        let key = descriptor.data.id(action.payload.item);

        var _ref2 = yield (0, _effects.race)({
            cancel: (0, _fsaSaga.take)([descriptor.actions.READ_CANCEL, descriptor.actions.RESET]),
            res: api.get(path + '/' + key),
            timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout)
        });

        let res = _ref2.res,
            cancel = _ref2.cancel,
            timeout = _ref2.timeout;

        if (res && res.ok) {
            let data = yield (0, _effects.call)(() => res.json());
            yield (0, _fsaSaga.put)(descriptor.actions.READ_SUCCESS({
                item: (0, _extends7.default)({}, action.payload.item, data, (0, _defineProperty3.default)({}, _resource.fields.id, key))
            }));
            yield* next();
        } else if (cancel) {
            yield* next();
        } else if (timeout) {
            yield (0, _fsaSaga.put)(descriptor.actions.READ_FAILURE({ item: action.payload.item, reason: 'timedout' }));
            yield* next();
        } else {
            yield (0, _fsaSaga.put)(descriptor.actions.READ_FAILURE({ item: action.payload.item, reason: res.status + ' ' + res.statusText }));
            yield* next();
        }
    };
}
function sagaUpdate(api, path, descriptor) {
    return next => function* (action) {
        let key = descriptor.data.id(action.payload.item);
        let item = (0, _resource.stripFields)(action.payload.item);

        var _ref3 = yield (0, _effects.race)({
            cancel: (0, _fsaSaga.take)([descriptor.actions.UPDATE_CANCEL, descriptor.actions.RESET]),
            res: api.put(path + '/' + key, (0, _extends7.default)({}, item, { id: key })),
            timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout)
        });

        let res = _ref3.res,
            cancel = _ref3.cancel,
            timeout = _ref3.timeout;

        if (res && res.ok) {
            let data = yield (0, _effects.call)(() => res.json());
            yield (0, _fsaSaga.put)(descriptor.actions.UPDATE_SUCCESS({
                item: (0, _extends7.default)({}, action.payload.item, data, (0, _defineProperty3.default)({}, _resource.fields.id, data.id))
            }));
            yield* next();
        } else if (cancel) {
            yield* next();
        } else if (timeout) {
            yield (0, _fsaSaga.put)(descriptor.actions.UPDATE_FAILURE({ item: action.payload.item, reason: 'timedout' }));
            yield* next();
        } else {
            yield (0, _fsaSaga.put)(descriptor.actions.UPDATE_FAILURE({ item: action.payload.item, reason: res.status + ' ' + res.statusText }));
            yield* next();
        }
    };
}
function sagaDelete(api, path, descriptor) {
    return next => function* (action) {
        if (descriptor.fields.neverCommited(action.payload.item)) {
            yield (0, _fsaSaga.put)(descriptor.actions.DELETE_SUCCESS(action.payload.item));
            yield* next();
            return;
        }
        let key = descriptor.data.id(action.payload.item);
        let item = (0, _resource.stripFields)(action.payload.item);

        var _ref4 = yield (0, _effects.race)({
            cancel: (0, _fsaSaga.take)([descriptor.actions.DELETE_CANCEL, descriptor.actions.RESET]),
            res: api.del(path + '/' + key, item),
            timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout)
        });

        let res = _ref4.res,
            timeout = _ref4.timeout,
            cancel = _ref4.cancel;

        if (res && (res.ok || res.status === http404)) {
            yield (0, _fsaSaga.put)(descriptor.actions.DELETE_SUCCESS(action.payload.item));
            yield* next();
        } else if (cancel) {
            yield* next();
        } else if (timeout) {
            yield (0, _fsaSaga.put)(descriptor.actions.DELETE_FAILURE({ item: action.payload.item, reason: 'timedout' }));
            yield* next();
        } else {
            yield (0, _fsaSaga.put)(descriptor.actions.DELETE_FAILURE({ item: action.payload.item, reason: res.status + ' ' + res.statusText }));
            yield* next();
        }
    };
}
function sagaList(api, path, descriptor) {
    return next => function* (action) {
        try {
            var _ref5 = yield (0, _effects.race)({
                cancel: (0, _fsaSaga.take)([descriptor.actions.LIST_CANCEL, descriptor.actions.RESET]),
                res: api.get('' + path),
                timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout)
            });

            let res = _ref5.res,
                cancel = _ref5.cancel,
                timeout = _ref5.timeout;

            if (res && res.ok) {
                let data = yield (0, _effects.call)(() => res.json());
                yield (0, _fsaSaga.put)(descriptor.actions.LIST_SUCCESS({
                    list: data.map(item => {
                        var _extends5;

                        return (0, _extends7.default)((_extends5 = {}, (0, _defineProperty3.default)(_extends5, _resource.fields.id, descriptor.data.id(item)), (0, _defineProperty3.default)(_extends5, _resource.fields.isRead, true), _extends5), item);
                    }),
                    params: action.payload.params
                }));
                yield* next();
            } else if (cancel) {
                yield* next();
            } else if (timeout) {
                yield (0, _fsaSaga.put)(descriptor.actions.LIST_FAILURE({ params: action.payload.params, reason: 'timedout' }));
                yield* next();
            } else {
                yield (0, _fsaSaga.put)(descriptor.actions.LIST_FAILURE({ params: action.payload.params, reason: res.status + ' ' + res.statusText }));
                yield* next();
            }
        } catch (ex) {
            yield (0, _fsaSaga.put)(descriptor.actions.LIST_FAILURE({ params: action.payload.params, reason: '' + ex.message }));
        }
    };
}
//# sourceMappingURL=HttpMiddleware.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/middlewares/HttpMiddleware.js